import Router from 'next/router'
import { mutate } from 'swr'
import { logout as logoutReq } from './useUser'

let isLoggingOut = false

export default function logout() {
  if (isLoggingOut) return
  isLoggingOut = true

  logoutReq()

  window.OneSignalDeferred = window.OneSignalDeferred || []
  // eslint-disable-next-line no-undef
  OneSignalDeferred.push(async function (OneSignal) {
    try {
      await OneSignal.logout()
    } catch (error) {
      console.error('OneSignal logout failed:', error)
    }
  })

  if (
    !Router.pathname.startsWith('/login') &&
    !Router.pathname.startsWith('/passwordreset') &&
    !Router.pathname.startsWith('/signup') &&
    !('invite' in Router.query) &&
    !('bid' in Router.query)
  ) {
    mutate(
      // eslint-disable-next-line no-unused-vars
      (key) => true,
      undefined,
      { revalidate: false }
    )

    Router.push('/signup').finally(() => {
      isLoggingOut = false
    })
  } else {
    isLoggingOut = false
  }
}
